import { t } from "@lingui/macro"
import { Typography } from "@mui/material"
import { memo } from "react"

export const ConfigurableDynamicFormFieldsUnhandledElementUi = memo(() => (
    <Typography variant="body2" gutterBottom>
        {t`configurable-dynamic-form-fields-component.form-fields.unknown-field-type`}
    </Typography>
))
